import React, { useEffect, useState } from "react";
import styles from "./Subscription.module.scss";
import { downloadFile, formatDateToReadable } from "utils/constants";
import {
  debounce,
  getStatusOption,
  selectStyles,
  statusOptions,
} from "../constants";
import { Controller, useForm } from "react-hook-form";
import SelectCustom from "components/common/Select/Select";
import ViewSVG from "components/SVGComponents/ViewSVG";
import DownloadIconSVG from "components/SVGComponents/DownloadIconSVG";
import { combineClasses } from "utils/utils";
import {
  exportSubscriptions,
  getAllSubscriptions,
  handleSubscriptionStatus,
} from "reducer/admin/subscriptionSlice";
import { useDispatch, useSelector } from "react-redux";
import CustomHeader from "components/common/CustomHeader/CustomHeader";
import Table from "components/common/Table/Table";
import ReportReason from "../SharedComponents/ReportReason/ReportReason";
import ReportModal from "components/UI/ReportModal/ReportModal";
import FilterModal from "./FilterModal";
import { accountStatusOptions } from "utils/utils";

const Subscription = () => {
  const [pageSelected, setPageSelected] = useState(1);
  const [rowsPerPageValue, setRowsPerPageValue] = useState(10);
  const [reportModal, setReportModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [reportText, setReportText] = useState("");
  const [reasonModal, setReasonModal] = useState("");
  const [search, setSearch] = useState("")
  const { control } = useForm();
  const dispatch = useDispatch();

  const { subscriptions, totalCount, isSubscriptionsLoading, isExporting } =
    useSelector((state) => state.subscriptions);

  const handleToggleStatus = async (row) => {
    try {
      await dispatch(
        handleSubscriptionStatus({
          id: row.id,
          status: !row.subscriptionStatus,
          message: reportText,
        })
      ).unwrap();
      setReportModal(false);
      setReportText("");
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSearch = debounce((value) => {
    dispatch(getAllSubscriptions({ pageSelected, search: value }));
    setSearch(value)
  }, 500);

  const handleExport = async () => {
    const res = await dispatch(exportSubscriptions()).unwrap();
    downloadFile(res);
  };

  const handleReportModal = async (value, row) => {
    if (value === "inActive") {
      setReportModal(true);
    } else {
      handleToggleStatus(row);
    }
  };

  const columns = [
    {
      name: "Business Name",
      selector: (row) => row?.companyName,
      width: "20%",
    },
    {
      name: "Account ID",
      selector: (row) => row?.id || "-",
      width: "16%",
    },
    {
      name: "Account Status",
      selector: (row) => {
        const matchedStatus = accountStatusOptions.find(
          (status) => status.value === row?.accountStatus
        );
        return (
          <p
            className={combineClasses(
              row?.accountStatus === "ACTIVE" ? styles.active : styles.inActive
            )}
          >
            {matchedStatus?.label || "-"}
          </p>
        );
      },
      width: "16%",
    },
    {
      name: "Plan",
      selector: (row) => {
        return row.plan || "-";
      },
      width: "16%",
    },
    {
      name: "Subscription Date",
      selector: (row) => formatDateToReadable(row.subscriptionDate)[0] || "-",
      width: "16%",
    },
    {
      name: "Expiry Date",
      selector: (row) => formatDateToReadable(row.expiryDate)[0] || "-",
      width: "16%",
    },
    // {
    //   name: "Subscription Status",
    //   selector: (row) => (
    //     <Controller
    //       name={`status-${row.id}`}
    //       control={control}
    //       defaultValue={getStatusOption(row.subscriptionStatus)}
    //       render={({ field }) => (
    //         <SelectCustom
    //           {...field}
    //           onChange={(selectedOption) => {
    //             field.onChange(selectedOption);
    //             handleReportModal(selectedOption?.value, row);
    //             setSelectedRow(row);
    //           }}
    //           value={getStatusOption(row.subscriptionStatus)}
    //           options={statusOptions}
    //           styles={selectStyles(!row.subscriptionStatus)}
    //         />
    //       )}
    //     />
    //   ),
    //   width: "15%",
    // },
    // {
    //   name: "Action",
    //   selector: (row) => {
    //     return (
    //       <div className={styles.actions}>
    //         <a
    //           href={`${filesAPI}${row?.url}`}
    //           download
    //           target="_blank"
    //           rel="noopener noreferrer"
    //           className={combineClasses(
    //             styles.actionIcon,
    //             !row?.url && styles.disabled
    //           )}
    //         >
    //           <DownloadIconSVG color="#7E7E7E" />
    //         </a>
    //         {row?.message && (
    //           <span
    //             className={styles.view}
    //             onClick={() => setReasonModal(row.message)}
    //           >
    //             <ViewSVG />
    //           </span>
    //         )}
    //       </div>
    //     );
    //   },
    //   width: "12%",
    // },
  ];

  useEffect(() => {
    dispatch(getAllSubscriptions({ pageSelected }));
  }, [pageSelected, dispatch]);

  const [openModal, setOpenModal] = useState(false);


  return (
    <>
      <div className={styles.main}>
        <CustomHeader
          handleSearch={handleSearch}
          isExporting={isExporting}
          handleExport={handleExport}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
        {openModal && <FilterModal onClose={() => setOpenModal(false)} search={search} />}

        <Table
          columns={columns}
          data={subscriptions || []}
          className={styles.candidatesTable}
          progressPending={isSubscriptionsLoading}
          paginationProps={{
            isPagination: true,
            tableName: "User Managenment",
            pageSelected,
            totalCount: totalCount,
            rowsPerPageValue,
            setRowsPerPageValue,
            setPageSelected,
          }}
        />
        {reportModal && (
          <ReportModal
            reportModal={reportModal}
            setReportModal={setReportModal}
            coverImage={false}
            type="user"
            handleSubmit={() => handleToggleStatus(selectedRow)}
            setReport={setReportText}
          />
        )}
      </div>
      {reasonModal && (
        <ReportReason reason={reasonModal} setReasonModal={setReasonModal} />
      )}
    </>
  );
};

export default Subscription;
